import { call, put, takeEvery } from 'redux-saga/effects'
import * as fromActions from '../../actions/access.action'
import canCourse from 'api/access/CanCourse'

async function getAccess(courseId: number) {
  return await canCourse(courseId)
}

function* canCourseListEffectSaga(action: any) {
  try {
    const { data } = yield call(getAccess, action.payload)
    yield put(fromActions.Actions.canCourseSuccess({ ...data, id: action.payload }))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* canCourseWatcherSaga() {
  yield takeEvery(fromActions.CAN_COURSE, canCourseListEffectSaga)
}
